// API
import api from '../../api'

// Utilities
import Gps from '../../utility/gpsUtil'
import Formatter from '../../utility/formatterUtil'
import Logger from '../../utility/loggerUtil'
import isEmpty from '../../utility/isEmpty'

export default {
  async getAppointment (context, data) {
    try {
      Logger.info('Using getAppointment action')
      const timezone = Gps.getTimezone()
      const response = await api.appointment.getAppointments(timezone, data.storeNumber, data.storeId, data.appointmentType)
      const appointments = response.appointments

      if (!isEmpty(response.storeInfo)) {
        context.commit('applicationRetailStore/setStore', {
          number: response.storeInfo.number,
          address: Formatter.toTitleCase(response.storeInfo.address),
          addressStreet: Formatter.toTitleCase(response.storeInfo.addressStreet),
          city: response.storeInfo.city ? Formatter.toTitleCase(response.storeInfo.city) : undefined,
          state: response.storeInfo.state,
          zip: response.storeInfo.zip,
          phone: response.storeInfo.phone,
          hoursRaw: response.storeInfo.hoursRaw,
          timezone: response.storeInfo.timezone,
          brandId: response.storeInfo.brandId,
          lat: response.storeInfo.latitude,
          long: response.storeInfo.longitude,
          name: response.storeInfo.name
        }, { root: true })
      }

      if (isEmpty(appointments)) {
        return []
      }

      const currentAppointment = response.appointments[0]
      context.commit('setAppointment', {
        storeNumber: data?.storeNumber ?? undefined,
        appointmentId: currentAppointment.id,
        appointmentDate: currentAppointment.appointmentDate,
        timezone: data.timezone
      })

      return appointments
    } catch (e) {
      Logger.error('Error on applicationAppointment/getAppointment')
      Logger.debug(e)
      throw e
    }
  },

  async scheduleAppointment (context, data) {
    try {
      // TODO, verify if using this in an application you have a loan header available
      const response = await api.appointment.createAppointment(
        undefined,
        data.loanHeader,
        data.appointmentDate,
        data.appointmentId,
        data.timezone,
        data.appointmentType,
        undefined,
        data.storeNumber)

      context.commit('setAppointment', {
        storeNumber: data.storeNumber,
        appointmentId: response.appointmentId,
        appointmentDate: data.appointmentDate,
        timezone: data.timezone,
        appointmentType: data.appointmentType
      })
      return response
    } catch (e) {
      Logger.error('Error on applicationAppointment/scheduleAppointment')
      Logger.debug(e)
      throw e
    }
  }
}
